module.exports = __webpack_public_path__ + "img/phone.8e492e05.svg";